"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uniqByProp = _interopRequireDefault(require("../../../../Util/uniqByProp"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(_ref) {
  var loading = _ref.loading,
      hasMoreItems = _ref.hasMoreItems,
      objects = _ref.objects,
      onEndReached = _ref.onEndReached,
      RenderComponent = _ref.RenderComponent,
      viewVariables = _ref.viewVariables,
      _ref$clientFilter = _ref.clientFilter,
      clientFilter = _ref$clientFilter === void 0 ? function (item) {
    return !!item;
  } : _ref$clientFilter,
      clientSort = _ref.clientSort,
      useButton = _ref.useButton,
      usedButton = _ref.usedButton,
      forceMore = _ref.forceMore;

  var handleEndReached = function handleEndReached() {
    if (window.innerHeight + window.scrollY - 50 >= document.body.offsetHeight) {
      console.log("you're at the bottom of the page", !!hasMoreItems);
      !!hasMoreItems && onEndReached();
    }
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', !!useButton || !!usedButton ? function () {
      return null;
    } : handleEndReached);
    return function () {
      return window.removeEventListener('scroll', handleEndReached);
    };
  }, [!!useButton, !!usedButton]);
  (0, _react.useEffect)(function () {
    !!forceMore && onEndReached();
  }, [forceMore]);
  console.log("RENDERING");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, objects.slice().filter((0, _uniqByProp["default"])('id')).sort(clientSort).filter(clientFilter).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(RenderComponent, _extends({
      key: item.id,
      id: item.id,
      object: item,
      filter: clientFilter
    }, viewVariables !== null && viewVariables !== void 0 ? viewVariables : {}));
  }) // !!loading ? "Loading..." :
  // <FlatList
  //   hasMoreItems={hasMoreItems}
  //   list={
  //     objects.filter(uniqByProp('id')).slice().sort(clientSort).filter(clientFilter)
  //   }
  //   loadMoreItems={onEndReached}
  //   renderItem={item => 
  //     <RenderComponent
  //       key={item.id}
  //       id={item.id}
  //       object={item}
  //       filter={clientFilter}
  //       {...viewVariables ?? {}}
  //     />
  //   }
  // />
  , !!useButton && !!hasMoreItems && !usedButton && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    fullWidth: true,
    variant: "contained",
    size: "large",
    color: "secondary",
    onClick: onEndReached,
    disabled: !!loading
  }, !!loading ? "Loading..." : "Load More"));
};

exports["default"] = _default;